import useSWR from 'swr';

import { fetchEndpointData } from '@/utils/fetch.client';

export interface Repository {
  id: string;
  name: string;
  description: string | null;
  provider: string;
  provider_repo_id: string | null;
  repo_full_name: string | null;
  default_branch: string | null;
  language: string | null;
  setup_commands: string[] | null;
  team_id: string;
  is_favorite: boolean;
  created_at: string;
  updated_at: string;
  workspace_count?: number;
  live_workspace_count?: number;
}

interface ListRepositoriesResponse {
  repositories: Repository[];
}

export function useRepositories(teamId: string | null) {
  const { data, mutate, isLoading } = useSWR(teamId ? `/api/v1/teams/${teamId}/repositories` : null, () =>
    fetchEndpointData<ListRepositoriesResponse>(`/api/v1/teams/${teamId}/repositories`),
  );
  return { repositories: data?.repositories ?? [], mutate, isLoading };
}

export async function createRepository(
  teamId: string,
  body: {
    name: string;
    description: string | null;
    provider: string;
    provider_repo_id: string;
    repo_full_name: string;
    default_branch: string | null;
    language: string | null;
  },
): Promise<Repository> {
  const res = await fetchEndpointData<{ repository: Repository }>(`/api/v1/teams/${teamId}/repositories`, {
    method: 'POST',
    body,
  });
  return res.repository;
}

export async function updateSetupCommands(repositoryId: string, commands: string[]) {
  return fetchEndpointData(`/api/v1/repositories/${repositoryId}/setup-commands`, {
    method: 'PUT',
    body: { commands },
  });
}

export async function deleteRepository(repositoryId: string) {
  return fetchEndpointData(`/api/v1/repositories/${repositoryId}`, { method: 'DELETE' });
}

export async function toggleFavorite(repositoryId: string, isFavorite: boolean) {
  return fetchEndpointData('/api/v1/repositories/favorite', {
    method: 'POST',
    body: { repository_id: repositoryId, is_favorite: isFavorite },
  });
}
